import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const getPeopleNames = async (ptsPersonID) => {
  const service = getService(ServiceName.RecordPersonName);
  const response = await service.find({
    query: {
      ptsPersonID,
      IsDeleted: false,
      $sort: { Created: -1 },
    },
  });
  return response?.data || response || [];
};

export const getPersonName = async (ptsNameID) => {
  const response = await getService(ServiceName.RecordPersonName).get(ptsNameID);
  return response?.data || response;
};

export const createPersonName = async (payload) => {
  const service = getService(ServiceName.RecordPersonName);
  const response = await service.create(payload);
  return response?.data || response;
};

export const editPersonName = async (ptsNameID, payload) => {
  const service = getService(ServiceName.RecordPersonName);
  const response = await service.patch(ptsNameID, payload);
  return response?.data || response;
};

export const deletePersonName = async (ptsNameID) => {
  const service = getService(ServiceName.RecordPersonName);
  const response = await service.remove(ptsNameID);
  return response?.data || response;
};
